import getMediaFilePlaceholder, {} from "./getMediaFilePlaceholder";
export default function getMediaFileDisplay({ file, translate }) {
    const placeholder = getMediaFilePlaceholder({ file, translate });
    if (placeholder) {
        return { placeholder, file: null };
    }
    if (file?.url) {
        return { placeholder: null, file };
    }
    return { placeholder: getMediaFilePlaceholder({ file: null, translate }), file: null };
}
